(function() {
    'use strict';

    angular
        .module('app.directive')
        .directive('taishinTimeTooltip', taishinTimeTooltip);

    function taishinTimeTooltip() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controller: ControllerController,
            templateUrl: 'directive/taishinTimeTooltip.html',
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                width: '@',
                importData: '=',
                mode: '=',
                textAlign: '=',
                briefText: '=',
            }
        };
        return directive;

        function link() {}
    }
    /* @ngInject */
    function ControllerController(modalService) {
        var vm = this;
        //---Method--
        //vm.method = methodName; 
        //-----------
        init();

        function dataIint() {
            vm.view = {
                show: false,
                moreShow: false,
                showBrief: false,
                briefIsRange: false,
                contentSperate: false,
                isForceBrief: false,
                //scale:-53,
                isMobile: modalService.isMobile,
            };
            vm.style = {
                contentStyle: {

                },
                textStyle: {

                }
            };
            vm.data = {
                importData: angular.copy(vm.importData) || [],
                dateBrief: "",
                dateList: []
            };
        }

        function init() {
            dataIint();
            logicInit();
            vm.view.show = true;
            //vm.view.scale=ScaleChange(vm.view.scale);
            //console.log('vm.view.scale:',vm.view.scale);
        }

        function logicInit() {
            styleLoading();
            if (vm.briefText || vm.briefText === 0) {
                vm.data.dateBrief = vm.briefText + '';
                vm.view.isForceBrief = true;
                vm.view.showBrief = true;
            }
            switch (vm.mode) {
                case "rough":
                    roughProcess();
                    break;
                default:
                    dateProcess();
                    vm.view.contentSperate = true;
                    break;
            }
        }

        function styleLoading() {
            if (vm.textAlign === 'center') {
                vm.style.textStyle["text-align"] = 'center';
            } else if (vm.textAlign === 'left') {
                vm.style.textStyle["text-align"] = 'left';
            } else if (vm.textAlign === 'right') {
                vm.style.textStyle["text-align"] = 'right';
            }

            if (vm.width) {
                vm.style.contentStyle.width = vm.width + 'px';
            }
        }

        function roughProcess() {
            vm.data.dateList = contentFixBr(vm.data.importData);
            // vm.data.dateBrief = "";
            vm.view.moreShow = (vm.data.importData.length > 0);
        }

        function dateProcess() {
            vm.data.dateList = getDateRange(vm.data.importData);
            if (!vm.view.isForceBrief) {
                vm.data.dateBrief = vm.data.dateList[0].split('~')[0];
            }
            vm.view.briefIsRange = (vm.data.dateList[0].split('~').length > 1);
            vm.view.moreShow = (vm.view.briefIsRange || vm.data.dateList.length > 1);
            vm.view.showBrief = true;
        }

        function getDateRange(rawStr) {
            //取得來源字串內的"日期區間"
            var getRange = /(\d{4}\/\d{1,2}\/\d{1,2}(\s*~\s*)?(\d{4}\/\d{1,2}\/\d{1,2})?(\([\w\W]*\))?)/g;
            var sourceStr = angular.copy(rawStr) || "";
            var resultStr = [];
            var match = null;
            //==若有其他狀況就依序取代與處理==
            do {
                if (match !== null) {
                    var timeAry = match[0].split('~');
                    var matchResult;
                    if (timeAry.length > 1) {
                        if (timeAry[0].trim() === timeAry[1].trim()) { matchResult = timeAry[0]; } else { matchResult = match[0]; }
                    } else {
                        matchResult = match[0];
                    }
                    if (resultStr.indexOf(matchResult) === -1) {
                        resultStr.push(matchResult);
                    }
                }
                match = getRange.exec(sourceStr);
            } while (match !== null);
            //=========
            if (resultStr.length < 1) { resultStr[0] = ""; }
            return resultStr;
        }

        function contentFixBr(rawData) {
            var getRange = /(<br\/?>)/g;
            var exceptCheck = /(<br\/?>)/;
            var sourceStr = (rawData && (typeof rawData === 'string')) ? angular.copy(rawData) : '';
            var resultStr = [];
            var match;
            try { match = sourceStr.split(getRange); } catch (exp) { console.log("sourceStr", sourceStr); }
            match = sourceStr.split(getRange);
            //==若有其他狀況就依序取代與處理==
            _.forEach(match, function(value) {
                if (!value) { return; }
                if (value.length < 1) { return; }
                if (exceptCheck.test(value)) { return; }
                if (resultStr.indexOf(value) === -1) {
                    resultStr.push(value);
                }
            });
            //=========
            return resultStr;
        }

        // function ScaleChange(data){
        //     var value = data;
        //     if(vm.view.isMobile){

        //         //value=value-30;
        //     }
        //     return value;
        // }
    }
})();